"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultValues = void 0;
var defaultValues = exports.defaultValues = {
  incomeGoalPercent: '85',
  inflationRate: '2',
  lifeExpectancy: '93',
  rorPostRetirement: '5',
  rorPreRetirement: '5',
  salaryGrowth: '2',
  ssBenefit: ''
};